<template>
  <transition :name="!forbiddenTransition ? 'fade-wrap' : ''">
    <div :class="{ 'mobile-searchKeys': isMobile, searchKeys: !isMobile }" class="search">
      <div class="mobile-search" v-show="isMobile">
        <img src="@imgs/back_mobile.png" @touchend="backBtn" class="backBtn" />
        <input v-model="searchKey" @keyup.enter="search(1, searchKey)" />
        <img src="@imgs/search_word.png" alt="" class="input_icon input_sear" />
        <img src="@imgs/close_searResult.png" alt="关闭" class="input_icon input_close" @touchend="clearInput" />
        <button @touchend="search(1, searchKey)">搜索</button>
      </div>
      <p class="result">
        {{ Moblength }}
        <img src="@imgs/close_searResult.png" alt="关闭" @click="close" v-if="!isMobile" />
      </p>
      <div class="line" v-show="Moblength && isLock"></div>
      <el-scrollbar>
        <div v-for="(item, index) in searchResult" :key="index" v-show="searchResult && searchResult.length > 0"
          class="keyShow">
          <p class="page">第{{ item.pageIndex }}页</p>
          <p class="content" v-html="item.lineText" @click="toGo(item.pageIndex, index, item)" v-show="isMobile"
            :class="{ curBg: current == index }"></p>
          <p class="content content-pc" v-html="item.lineText" @click="toGo(item.pageIndex, index, item)"
            v-show="!isMobile" :class="{ curBg: current == index }"></p>
          <div class="line" v-show="isMobile"></div>
        </div>
      </el-scrollbar>
    </div>
  </transition>
</template>
<script>
import apis from '@api/getBook'
import axios from 'axios'
import { isPureNum } from '@/utils'
export default {
  name: 'searchKeys',
  props: {
    forbiddenTransition: {
      default: false
    }
  },
  data() {
    return {
      isShow: true,
      length: null,
      searchResult: [],
      posList: [],
      searchKey: '',
      isLock: true,
      curKey: '',
      lockPos: false,
      Moblength: null,
      test: 2,
      decryption_id: isPureNum(this.$route.query.id),
      current: null,
      currentpageClick: '',
      curPage: null
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    // 本组件直接修改了store，会导致do not mutate vuex store state outside mutation handlers.暂未修复
    pages() {
      return this.$store.state.book.pages
    },
    currentPage() {
      let currentPageArray = this.$store.state.book.currentPage
      let page
      if (currentPageArray[0] === 0) {
        page = currentPageArray[1] + '/' + this.totalPage
      } else if (currentPageArray[1] === 0) {
        page = currentPageArray[0] + '/' + this.totalPage
      } else {
        page = currentPageArray.join(' - ') + '/' + this.totalPage
      }
      return page
    },
    currentPageNum() {
      return this.currentPage.split('/')[0]
    },
    splitCurrentPage() {
      let page
      if (this.currentPageNum.indexOf('-') > -1) {
        page = this.currentPageNum.split('-')[1]
      } else {
        page = this.currentPageNum
      }
      return page
    },
    totalPage() {
      return this.$store.state.book.totalPage
    },
    getYellow() {
      return this.$store.state.book.yellow - this.test
    },
    readModel() {
      return this.$store.state.book.bookData.readModel
    }
  },
  methods: {
    /**
     * 是否是数字报刊
     * @returns {boolean}
     */
    hasPaper() {
      return window.location.hash.indexOf('/paper') !== -1 || window.location.hash.indexOf('/paperContent') !== -1 || window.location.hash.indexOf('/paperTurn?') !== -1 || window.location.hash.indexOf('/paperContentTurn') !== -1
    },
    close() {
      this.$emit('closenow', false)
      // 取消标黄
      this.$store.commit('book/UPDATE_ISSHOWYELLOW', false)
      this.lockPos = false
      this.isShow = false
    },
    toGo(pageMessage, index, item) {
      this.$emit('togo', item)
      this.current = index
      this.$store.commit('book/UPDATE_GOPAGE', pageMessage)
      let currentPageIndex = 0
      for (let i = 0; index < this.searchResult.length; i++) {
        if (this.searchResult[i].pageIndex == pageMessage) {
          currentPageIndex = i
          break
        }
      }
      this.currentpageClick = index - currentPageIndex
      this.curPage = pageMessage
      window.sessionStorage.setItem('curClickPage', String(pageMessage))
      if (this.isMobile) {
        this.$emit('closenow', false)
      }
      /*
          兼容同一页关键字颜色变化 双页 三种情况
          1. 本次页数和上次页数相同
          2. 上次页数为偶数 +1 本次页数为奇数 且不是最后一页 不能为0
          3. 上次页数为奇数 -1 本次页数为偶数 且不是首页
        */
      const beforeClickPage = Number(window.sessionStorage.getItem('curClickPage'))
      const beforeEven = beforeClickPage % 2 == 0 && beforeClickPage != this.totalPage && beforeClickPage !== 0 && beforeClickPage + 1 == pageMessage
      const beforeOdd = beforeClickPage % 2 == 1 && beforeClickPage != 1 && beforeClickPage - 1 == pageMessage
      const beforeEqual = beforeClickPage === pageMessage ? true : false
      if (beforeEqual || beforeOdd || beforeEven) {
        // 兼容同一页关键字颜色变化
        const curArrIndex = this.pages.findIndex(function (ele) {
          if (ele.posiArr && ele.posiArr.length > 0) {
            return ele.posiArr[0].pageIndex === pageMessage
          }
        })
        // 清除添加的颜色
        this.pages.forEach((item) => {
          if (item.posiArr && Array.isArray(item.posiArr)) {
            item.posiArr.forEach((ele) => {
              this.$set(ele, 'bg', '')
            })
          }
        })
        if (curArrIndex >= 0) {
          const arr = this.pages[curArrIndex].posiArr
          const l = arr.length
          if (l > 0) {
            let lastY = null
            let currentIndex = 0
            for (let i = 0; i < l; i++) {
              if (arr[i].y != lastY) {
                lastY = arr[i].y
                if (currentIndex === this.currentpageClick) {
                  this.$set(arr[i], 'bg', 'blue')
                } else {
                  this.$set(arr[i], 'bg', '')
                }
                currentIndex += 1
              } else {
                this.$set(arr[i], 'bg', '')
              }
            }
            // arr.forEach((item, index) => {
            //   if (index === this.currentpageClick) {
            //     this.$set(item, 'bg', 'blue')
            //   } else {
            //     this.$set(item, 'bg', '')
            //   }
            // })
            this.$store.commit('book/UPDATE_PAGES', this.pages)
          }
        }
        window.sessionStorage.setItem('curClickPage', String(pageMessage))
      }
    },
    backBtn() {
      this.$emit('closenow', false)
      this.$store.commit('book/UPDATE_ISSHOWYELLOW', false)
    },
    // 搜索书刊文字
    search(pageNo, searchKey) {
      if (searchKey.trim() === '') {
        if (this.isMobile) {
          this.$message({
            message: '关键字不能为空',
            duration: 3000,
            customClass: 'el-message-class-seachkey',
            center: true,
            type: 'warning'
          })
        } else {
          this.$alert('关键字不能为空', '提示', {
            confirmButtonText: '确定'
          })
        }
        return false
      }
      if (searchKey.trim().length < 2) {
        if (this.isMobile) {
          this.$message({
            message: '关键字最少输入两个字',
            duration: 3000,
            customClass: 'el-message-class-seachkey',
            center: true,
            type: 'warning'
          })
        } else {
          this.$alert('关键字最少输入两个字', '提示', {
            confirmButtonText: '确定'
          })
        }
        return false
      }
      if (!this.isMobile && pageNo == 1) {
        this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
        this.$store.commit('book/UPDATE_ISSHOWWINDOW', 1)
        this.$emit('closenow', true)
        this.isShow = true
      }
      this.$store.commit('book/UPDATE_ISSHOWYELLOW', true)
      let params = {
        id: this.decryption_id,
        key: searchKey,
        pageNo: pageNo
      }
      this.Moblength = '正在加载中...'
      this.isLock = true
      console.log(this.readModel)
      let result = []
      let daYangList = staticOptions.daYangList
      daYangList.forEach((daYangItem) => {
        daYangItem.xiaoYangList.forEach((xiaoYangItem) => {
          let str = (new DOMParser().parseFromString(xiaoYangItem.content, 'text/html')).body.textContent || ''
          let isFirst = true
          let index
          do {
            index = str.indexOf(searchKey, isFirst ? 0 : (index + searchKey.length + 9))
            isFirst = false
            if (index === -1) {
              return false
            }
            result.push({
              "id": xiaoYangItem.id,
              "title": xiaoYangItem.title,
              "lineText": str.slice(index - 9 >= 0 ? index - 9 : 0, index + 9),
              "edition": xiaoYangItem.edition,
              "xuHao": xiaoYangItem.xuHao,
              "pageIndex": daYangItem.pageNo
            })
          } while (index > -1)
        })
      })
      if (result.length < 1 && window.pdfText) {
        window.pdfText.forEach(item => {
          let isFirst = true
          let index = 0
          let startIndex = 0
          do {
            index = item.text.indexOf(searchKey, isFirst ? 0 : (index + searchKey.length))
            isFirst = false
            if (index === -1) {
              return false
            }
            result.push({
              "lineText": item.text.slice(Math.max(startIndex, index - 9), index + 9),
              "pageIndex": item.pageNum
            })
            startIndex = index + searchKey.length
          } while (index > -1)
        })
      }
      console.log(result)
      let res = { data: { data: { findList: result, count: result.length } } }
      if (pageNo == 1) {
        this.searchResult = []
        this.length = 0
        this.lockPos = true
        this.curKey = searchKey
        this.getKeyPos(this.lockPos)
      }
      this.searchResult = this.searchResult.concat(res.data.data.findList)
      this.searchResult.forEach((item) => {
        if (item && item.lineText.indexOf('<span') == -1) {
          const regExp = new RegExp(searchKey, 'gi')
          const match = item.lineText.match(regExp)
          for (let i = 0; i < match.length; i++) {
            item.lineText = item && item.lineText.replace(match[i], '<span style="color: red;">' + match[i] + '</span>')
          }
        }
      })
      this.length += res.data.data.count
      this.Moblength = '总共找到' + this.length + '条结果'
    },
    searchResultHandle(data, pageNo, searchKey) {
      if (pageNo == 1) {
        this.searchResult = []
        this.length = 0
        this.lockPos = true
        this.curKey = searchKey
        this.getKeyPos(this.lockPos)
      }
      this.searchResult = this.searchResult.concat(data.data.findList)
      this.searchResult.forEach((item) => {
        if (item && item.lineText.indexOf('<span') == -1) {
          item.lineText = item && item.lineText.replace(new RegExp(searchKey, 'g'), '<span style="color: red;">' + searchKey + '</span>')
        }
      })
      this.length += data.data.count
      if (data.data.endPage != -1 && this.isShow) {
        data.data.endPage++
        this.search(data.data.endPage, searchKey)
      } else {
        this.Moblength = '总共找到' + this.length + '条结果'
      }
    },
    getKeyPos(payload) {
      if (!payload) return
      let params = {
        id: this.decryption_id,
        key: this.curKey,
        pageNo: this.splitCurrentPage
      }
      let resultHandle = (res) => {
        if (res.data.data) {
          if (Array.isArray(this.pages)) {
            this.pages.forEach((item) => {
              if (item.posiArr && item.posiArr.length > 0) {
                item.posiArr = []
              }
            })
            this.$store.commit('book/UPDATE_PAGES', this.pages)
          }
          this.posList = []
          let data = res.data.data
          data.forEach((item) => {
            this.$set(item, 'bg', '')
          })
          let l = data.length
          let lastY = null
          let currentIndex = 0
          for (let i = 0; i < l; i++) {
            if (data[i].pageIndex === this.curPage) {
              if (data[i].y != lastY) {
                lastY = data[i].y
                if (currentIndex === this.currentpageClick) {
                  this.$set(data[i], 'bg', 'blue')
                  break
                }
                currentIndex += 1
              }
            }
          }
          // for (let i = 0; i < data.length; i++) {
          //   if (data[i].pageIndex === this.curPage) {
          //     const idx = i + this.currentpageClick
          //     if (typeof idx === 'number') {
          //       this.$set(data[idx], 'bg', 'blue')
          //     }
          //     break
          //   }
          // }
          this.posList = data
          this.$store.commit('book/UPDATE_POSITIONLIST', this.posList)
          let posArrList = this.handlerDatas(this.posList)
          if (this.pages) {
            for (let i = 1; i < this.pages.length + 1; i++) {
              posArrList.forEach((item) => {
                if (item.pageIndex == i) {
                  this.$set(this.pages[i - 1], 'posiArr', item.children)
                }
              })
            }
            this.$store.commit('book/UPDATE_PAGES', this.pages)
          }
        }
      }
      /*离线数据定位接口不能用
      if (this.hasPaper()) {
        if (this.readModel === 0) {
          apis.getEpaperKeyPos(params).then((res) => {
            resultHandle(res)
          })
        }
      } else {
        apis.getKeyPos(params).then((res) => {
          resultHandle(res)
        })
      }*/
    },
    clearInput() {
      this.searchKey = ''
    },
    handlerDatas(arr) {
      let obj = {}
      arr.forEach((item, index) => {
        let { pageIndex } = item
        if (!obj[pageIndex]) {
          obj[pageIndex] = {
            pageIndex,
            children: []
          }
        }
        obj[pageIndex].children.push(item)
      })
      let data = Object.values(obj) // 最终输出
      return data
    }
  },
  watch: {
    splitCurrentPage(val) {
      this.getKeyPos(this.lockPos)
    }
  }
}
</script>
<style lang="scss" scoped>
.search {
  position: absolute;
  left: 0;
  z-index: 1000;

  p {
    color: #515151;
    font-weight: 600;
  }

  .result {
    font-size: 16px;
    display: flex;
    justify-content: space-between;

    img {
      height: 15px;
      cursor: pointer;
    }
  }

  .page {
    font-size: 14px;
  }

  .content {
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    width: 100%;
  }

  .curBg {
    background-color: #fced00;
  }

  .content-pc {
    margin: 0;
    line-height: 18px;
    padding: 3px 0;
  }

  .line {
    height: 1px;
    background: #eaeaea;
  }

  input,
  textarea {
    -webkit-appearance: none;
    /*去除input默认样式*/
  }
}

.searchKeys {
  width: 300px;
  height: 100%;
  background: #fff;
  // padding-bottom: 40px;
  top: 40px;
  overflow: hidden;
  z-index: 2000 !important;

  .el-scrollbar {
    height: calc(100% - 60px);

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .keyShow {
    padding: 0 25px;
  }

  .result {
    width: 250px;
    margin: 16px auto;
  }

  .line {
    width: 250px;
    margin: 0 auto;
  }
}

.mobile-searchKeys {
  width: 100%;
  height: 100%;
  top: 0;
  background: #fff;
  z-index: 1000;
  padding: 20px;
  overflow: auto;
}

.mobile-search {
  display: flex;
  height: 30px;
  justify-content: space-between;
  position: relative;

  .backBtn {
    width: 30px;
  }

  input {
    width: 70%;
    border-radius: 4px;
    padding-left: 9%;
    border: 1px solid #000;
  }

  button {
    background: #3a3a3a;
    color: #fff;
    border-radius: 4px;
    border: none;
  }

  .input_icon {
    position: absolute;
    top: 5px;
    height: 20px;
  }

  .input_sear {
    left: 15%;
  }

  .input_close {
    left: 77%;
    height: 16px;
    top: 6px;
  }
}

.fade-wrap-enter-active,
.fade-wrap-leave-active {
  transition: all 0.5s;
}

.fade-wrap-enter,
.fade-wrap-leave-to {
  transform: translateX(-300px);
  opacity: 0;
}
</style>
